export const SelectorIcon = ({ rotate }: { rotate: boolean }) => {
  return (
    <svg width="12" height="12" style={{ transform: rotate ? 'rotate(180deg)' : 'none' }} viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.71973 4.74914C2.62162 4.63876 2.59742 4.48109 2.65792 4.34638C2.71841 4.21167 2.85233 4.125 3.00001 4.125H9.00001C9.14768 4.125 9.2816 4.21167 9.3421 4.34638C9.40259 4.48109 9.37839 4.63876 9.28029 4.74914L6.28028 8.12414C6.20912 8.2042 6.10712 8.25 6.00001 8.25C5.89289 8.25 5.79089 8.2042 5.71973 8.12414L2.71973 4.74914Z" fill="currentColor" />
    </svg>
  )
}